import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  drawer: boolean;
};

const initialState: InitialState = {
  drawer: false,
};

const drawerSlice = createSlice({
  name: "drawerSlice",
  initialState,
  reducers: {
    toggleDrawer: (state, action: PayloadAction) => {
      state.drawer = !state.drawer;
      return state;
    },
  },
});

export const { toggleDrawer } = drawerSlice.actions;
export default drawerSlice;